export const SOCIAL_MEDIAS = [
  {
    icon: "fab fa-facebook-square",
    url: "https://web.facebook.com/mercatorio",
  },
  {
    icon: "fab fa-instagram",
    url: "https://www.instagram.com/mercatorioinvestimentos",
  },
  {
    icon: "fab fa-linkedin",
    url: "https://www.linkedin.com/company/mercatorio",
  },
  {
    icon: "fab fa-youtube",
    url: "https://www.youtube.com/@Mercatorio",
  },
];
